import { createSelector } from 'reselect';
import { CONTENT_TYPES } from './constants';

export const getWorkflowWebhookState = (state) => state.integrations?.workflowWebhooks || {};

export const selectWorkflowWebhooksList = createSelector(getWorkflowWebhookState, (state) => {
  const webhooksList = state?.workflowWebhooksList || [];
  return webhooksList.map((webhook) => {
    if (webhook.contentType === CONTENT_TYPES.json.value) {
      let hasCustomJson = false;
      let hasUserFields = false;
      const content = webhook?.bodyOpt || [];
      const userFields = content
        .map((pair) => {
          if ('jsBody' in pair) {
            hasCustomJson = true;
          }
          hasUserFields = true;
          return pair.field;
        })
        .join(', ');
      const newWebhook = {
        ...webhook,
        hasCustomJson,
        hasUserFields,
        userFields,
      };
      return newWebhook;
    }
    return webhook;
  });
});
